import { FunctionComponent } from 'react';
import styles from './ReliefComponent.module.scss';
import FeedingMoments from 'components/CreateBooking/Daycare/FeedingsAndMedications/UI/FeedingMoments';
import { Relief } from 'model/NewMultipleBooking';

interface ReliefComponentProps {
    reliefState: Relief;
    disabled?: Array<number>;
    editing?: boolean;
    onReliefChange: (relief: Relief) => void;
}

const ReliefComponent: FunctionComponent<ReliefComponentProps> = ({
    reliefState,
    disabled,
    editing,
    onReliefChange
}) => {
    return (
        <>
            <div className={styles.timeSection}>
                <p className={styles.label}>Time</p>
                <FeedingMoments
                    disabled={disabled}
                    editing={editing}
                    selectedMoments={reliefState.momentTypes}
                    onMomentsChange={(moments: Array<number>) =>
                        onReliefChange({ ...reliefState, momentTypes: moments })
                    }
                />
            </div>
            <div className={styles.noteSection}>
                <p className={styles.label}>Task Note</p>
                <textarea
                    className={styles.notesTextarea}
                    value={reliefState.notes ?? ''}
                    onChange={e => onReliefChange({ ...reliefState, notes: e.target.value })}
                    placeholder="Notes here..."
                    rows={3}
                />
            </div>
        </>
    );
};

export default ReliefComponent;
